import { toString } from 'lodash';


const getSlugValue = (slug: string | null | undefined): string =>
  toString(slug?.toLowerCase()?.replace(/\s/g, '-'));

export default getSlugValue;
